import axios, {AxiosError, AxiosResponse} from 'axios';
import queryString from 'query-string';
import {ErrorObject} from 'types';
import {RecipeObject} from '../types';

/**
 * The interface of get exercises params.
 */
export interface GetRecipeParams {
  title?: RecipeObject['title'];
  my?: string;
  skip?: string;
  limit?: string;
}

/**
 * Get all exercises from the store.
 * @return {Promise<RecipeObject[] | ErrorObject | undefined>}
 */
export async function getRecipes(params?: GetRecipeParams) {
  return axios({
    method: 'GET',
    url: queryString.stringifyUrl({
      url: `${process.env.REACT_APP_API_BASE_URL}/recipes`,
      query: params && {
        ...params,
      },
    }),
  }).then((response: AxiosResponse<RecipeObject[]>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}
